import styled from 'styled-components';

import { Link } from '@dreryk/react-components';

export const StyledOpenAddModalLink = styled(Link)`
   align-self: flex-end;
`;

StyledOpenAddModalLink.displayName = 'StyledOpenAddModalLink';
